
import VueApp from '@/@types/app/VueApp';
import { Component, Watch } from 'vue-property-decorator';

@Component({
  name: 'ArticleGroupDialog',
})
export default class ArticleGroupDialog extends VueApp {
  groupName = '';
  showDialog = false;
  mode: 'create' | 'rename' = 'create';
  resolve: ((value?: string | PromiseLike<string>) => void) | null = null;
  reject: ((reason?: any) => void) | null = null;
  initValidate = false;

  $refs: {
    groupNameInput: any;
  };

  get dialogTitle(): string {
    return this.mode === 'create' ? 'Create a Group' : 'Rename Group';
  }

  show(mode: 'create' | 'rename' = 'create', currentName = ''): Promise<string> {
    this.mode = mode;
    this.groupName = currentName;
    this.initValidate = false;

    return new Promise<string>((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
      this.showDialog = true;
    });
  }

  isValid() {
    return !this.initValidate || this.groupName.trim().length > 0;
  }

  canSave() {
    return this.groupName.trim().length > 0;
  }

  validate() {
    this.initValidate = true;
    return this.isValid();
  }

  handleSave() {
    this.initValidate = true;
    if (this.validate() && this.canSave()) {
      const trimmedName = this.groupName.trim();
      this.resolve(trimmedName);
      this.showDialog = false;
      this.resetDialog();
    }
  }

  handleCancel() {
    this.reject(new Error('Dialog cancelled'));
    this.showDialog = false;
    this.resetDialog();
  }

  resetDialog() {
    this.groupName = '';
    this.initValidate = false;
    this.mode = 'create';
  }

  @Watch('showDialog')
  onDialogChange(value: boolean) {
    if (value) {
      // Auto-focus the input when dialog opens
      this.$nextTick(() => {
        if (this.$refs.groupNameInput) {
          this.$refs.groupNameInput.$el.focus();
        }
      });
    } else {
      this.initValidate = false;
    }
  }
}
